import { CM_CHECKLIST_CATEGORIES } from './constants';
import type { ChecklistCategory, ChecklistCategoryId } from './types';

export const CAMPAIGN_CATEGORY = getChecklistCategory('campaign');
export const DISCOUNTS_MARGIN_CATEGORY = getChecklistCategory('discountsMargin');
export const EGS_CATEGORY = getChecklistCategory('egs');
export const DEAL_OPTIONS_INCLUSIONS_CATEGORY = getChecklistCategory('dealOptionsInclusions');
export const SETUP_CATEGORY = getChecklistCategory('setup');
export const SURCHARGES_CATEGORY = getChecklistCategory('surcharges');
export const TAXES_PAYMENTS_CATEGORY = getChecklistCategory('taxesPayments');
export const BLACKOUT_CATEGORY = getChecklistCategory('blackoutDates');
export const BUNDLED_EXPERIENCES_CATEGORY = getChecklistCategory('bundledExperiences');

export function getChecklistCategory(categoryId: ChecklistCategoryId): ChecklistCategory {
  return CM_CHECKLIST_CATEGORIES.find((category) => category.id === categoryId) ?? CM_CHECKLIST_CATEGORIES[0];
}
